/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Decks_My_DeckInputs */



/**
* | output |
* | --- |
* | "Your Deck" |
*
* @param {Decks_My_DeckInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const decks_my_deck = /** @type {((inputs?: Decks_My_DeckInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Decks_My_DeckInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Votre deck")
	if (locale === "es") return /** @type {LocalizedString} */ ("Su Deck")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Seu Deck")
	if (locale === "it") return /** @type {LocalizedString} */ ("Il Tuo Deck")
	return /** @type {LocalizedString} */ ("Your Deck")
});